module.exports = __webpack_public_path__ + "img/20.f4bbbbc4.jpg";